
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Dialog from '@/components/Dialog.vue';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';

const { merchantcategory } = api;

@Component({
  components: {
    Dialog,
  },
  mixins: [ruleMixin],
})
export default class MerchantCategoryForm extends Vue {
  @Prop() private id!: string;

  private loading = false;

  private valid = true;

  private form = {
    categoryName: '',
  };

  private async save() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const { status } = this.isEdit
        ? await merchantcategory.edit(this.id, this.form)
        : await merchantcategory.add(this.form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        await this.$router.back();
      }
    }
  }

  private async close() {
    await this.$router.back();
  }

  private get isEdit() {
    return !!this.id;
  }

  private get title() {
    return this.isEdit ? '編輯' : '新增';
  }

  private async setForm(form: any) {
    this.form = { ...form };
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: MerchantCategoryForm) => void) | boolean) => void,
  ) {
    if (to.name === 'merchantCategoryEdit') {
      const { data } = await merchantcategory.get(to.params.id);
      await next(async (vm) => {
        vm.setForm(data);
      });
    } else {
      await next(true);
    }
  }
}
